import React, { useEffect, useState } from 'react'

// redux
import { connect } from 'react-redux'

// icons
import FeatherIcon from 'feather-icons-react';

// APIs
import { verifyDKIMApi, verifyReturnPathApi } from 'utlis/Apis/Notifications_API';

// react bootstrap
import { Spinner } from 'react-bootstrap';

// react toastify
import { toast } from 'react-toastify';

// messages
import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME
} from 'utlis/AppMessages/AppMessages'

function DomainSettings(props) {
    // props
    const {
        authState,
        setDNSsettingsVisibility,
        notificationsData,
        setNotificationsData,
    } = props

    // states
    const [DKIM_btnDisabled, setDKIM_btnDisabled] = useState(false)
    const [DKIM_btnLoading, setDKIM_btnLoading] = useState(false)
    const [ReturnPath_btnDisabled, setReturnPath_btnDisabled] = useState(false)
    const [ReturnPath_btnLoading, setReturnPath_btnLoading] = useState(false)

    const [domainDetails, setDomainDetails] = useState(null)

    // setting domaindetails
    useEffect(() => {
        if (notificationsData?.postmark_domain_detail) {
            const data = JSON.parse(notificationsData?.postmark_domain_detail)

            setDomainDetails(data) // setting domain details
        }
    }, [notificationsData])


    // on verify DKIM token button click
    const handleVerifyDKIMbuttonClick = ev => {
        ev.preventDefault()

        // button loading
        setDKIM_btnDisabled(true)
        setDKIM_btnLoading(true)

        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        // network request
        verifyDKIMApi(headers).then(res => {
            // button loading
            setDKIM_btnDisabled(false)
            setDKIM_btnLoading(false)

            const resData = res.data
            // if request succesfull
            if (resData && resData.success) {
                setNotificationsData(resData.data) // setting notifications data

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the success message
                toast.success("Success", {
                    autoClose: 2500
                })
            }

            // if request is not succesfull
            if (resData && resData.error) {
                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(resData?.message ?? UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} verifyDKIMApi `, err.message)

            // dismissing all the previous toasts first
            toast.dismiss();

            // showing the error message
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    // button loading
                    setDKIM_btnDisabled(false)
                    setDKIM_btnLoading(false)
                }
            })
        })
    }

    // on verify return path button click
    const handleVerifyReturn_PathbuttonClick = ev => {
        ev.preventDefault()
        // button loading
        setReturnPath_btnDisabled(true)
        setReturnPath_btnLoading(true)

        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        // network request
        verifyReturnPathApi(headers).then(res => {
            // button loading
            setReturnPath_btnDisabled(false)
            setReturnPath_btnLoading(false)

            const resData = res.data
            // if request succesfull
            if (resData && resData.success) {
                setNotificationsData(resData.data) // setting notifications data

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the success message
                toast.success("Success", {
                    autoClose: 2500
                })
            }

            // if request is not succesfull
            if (resData && resData.error) {
                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(resData?.message ?? UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} verifyReturnPathApi `, err.message)

            // dismissing all the previous toasts first
            toast.dismiss();

            // showing the error message
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    // button loading
                    setReturnPath_btnDisabled(false)
                    setReturnPath_btnLoading(false)
                }
            })
        })
    }

    return (
        <div className="page-border-box2 mb-3 mb-md-4 domain-settings">
            <div className="pbb2-inner">
                {/* head */}
                <div className="app-header-wrapper heading-sm d-flex align-items-start mb-2">
                    <p className="app-heading st-fw-600 text-capitalize mb-0">
                        DNS Settings
                        <span className="d-block st-fs-16" style={{ textTransform: 'initial' }}>{notificationsData?.postmark_domain}</span>
                    </p>
                    <a href="/" className="text-decoration-none d-inline-flex align-items-center ms-auto st-text-primary mt-1" onClick={ev => {
                        ev.preventDefault()

                        setDNSsettingsVisibility(false) // closing the settings
                    }}>
                        <FeatherIcon
                            icon="x"
                            size="15"
                            className="icon"
                        />
                        <span className="ms-1">
                            Close Settings
                        </span>
                    </a>
                </div>

                <div className="content">
                    <p className="desc text-center mt-2 mb-3 st-text-color2 st-fs-15">
                        Head over to your DNS provider and add <span className="text-decoration-underline">DKIM</span> and <span className="text-decoration-underline">Return-Path</span> DNS
                        records to verify your domain and ensrure effective delivery.
                    </p>

                    <div className="table-responsive dns-settings-table">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th className="st-fw-400"></th>
                                    <th className="st-fw-400">
                                        <p className="st-text-color2">Hostname</p>
                                    </th>
                                    <th width={80} className="st-fw-400">
                                        <p className="text-center st-text-color2">Type</p>
                                    </th>
                                    <th width={250} className="st-fw-400">
                                        <p className="st-text-color2">Add this value</p>
                                    </th>
                                    <th width={90} className="st-fw-400"></th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr>
                                    <td className="status">
                                        <div className={`d-flex align-items-center ${domainDetails?.dkimverified ? "active" : "inactive"}`}>
                                            <button className={`st-round-btn st-btn-xs d-flex align-items-center justify-content-center cursor-pointer ${domainDetails?.dkimverified ? "st-btn-primary" : "st-btn-disabled-like"}`}>
                                                <FeatherIcon
                                                    icon={domainDetails?.dkimverified ? "check" : "x"}
                                                    size="17"
                                                    className="icon"
                                                />
                                            </button>
                                            <p className="media-body d-flex flex-column ps-2 st-line-height-normal">
                                                <span className="st-fw-600 st-fs-15">DKIM</span>
                                                <span className="st-text-color2">{domainDetails?.dkimverified ? "Active" : "Inactive"}</span>
                                            </p>
                                        </div>
                                    </td>

                                    <td className="hostname">
                                        <p>
                                            {domainDetails?.dkimpendinghost ?? ""}
                                        </p>
                                    </td>

                                    <td className="type">
                                        <p className="text-center">
                                            TXT
                                        </p>
                                    </td>

                                    <td className="this-value">
                                        <p>
                                            {domainDetails?.dkimpendingtextvalue ?? ""}
                                        </p>
                                    </td>

                                    <td className="btns text-right">
                                        {
                                            !domainDetails?.dkimverified ? (
                                                <button
                                                    className={`st-btn st-btn-primary st-btn-sm no-min-width st-fs-13 ${DKIM_btnDisabled ? "disabled" : ""}`}
                                                    disabled={DKIM_btnDisabled}
                                                    onClick={ev => handleVerifyDKIMbuttonClick(ev, domainDetails?.dkimpendingtextvalue)}
                                                    style={{ minWidth: 68 }}>
                                                    {
                                                        DKIM_btnLoading ? (
                                                            <Spinner animation="border" size="sm" />
                                                        ) : (
                                                            "Verify"
                                                        )
                                                    }
                                                </button>
                                            ) : null
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td className="status">
                                        <div className={`d-flex align-items-center ${domainDetails?.returnpathdomainverified ? "active" : "inactive"}`}>
                                            <button className={`st-round-btn st-btn-xs d-flex align-items-center justify-content-center cursor-pointer ${domainDetails?.returnpathdomainverified ? "st-btn-primary" : "st-btn-disabled-like"}`}>
                                                <FeatherIcon
                                                    icon={domainDetails?.returnpathdomainverified ? "check" : "x"}
                                                    size="17"
                                                    className="icon"
                                                />
                                            </button>
                                            <p className="media-body d-flex flex-column ps-2 st-line-height-normal">
                                                <span className="st-fw-600 st-fs-15">Return-Path</span>
                                                <span className="st-text-color2">{domainDetails?.returnpathdomainverified ? "Active" : "Inactive"}</span>
                                            </p>
                                        </div>
                                    </td>

                                    <td className="hostname">
                                        <p>
                                            pm-bounces
                                        </p>
                                    </td>

                                    <td className="type">
                                        <p className="text-center">
                                            CNAME
                                        </p>
                                    </td>

                                    <td className="this-value">
                                        <p>
                                            {domainDetails?.returnpathdomaincnamevalue ?? ""}
                                        </p>
                                    </td>

                                    <td className="btns text-right">
                                        {
                                            !domainDetails?.returnpathdomainverified ? (
                                                <button
                                                    className={`st-btn st-btn-primary st-btn-sm no-min-width st-fs-13 ${ReturnPath_btnDisabled ? "disabled" : ""}`}
                                                    disabled={ReturnPath_btnDisabled}
                                                    onClick={handleVerifyReturn_PathbuttonClick}
                                                    style={{ minWidth: 68 }}>
                                                    {
                                                        ReturnPath_btnLoading ? (
                                                            <Spinner animation="border" size="sm" />
                                                        ) : (
                                                            "Verify"
                                                        )
                                                    }
                                                </button>
                                            ) : null
                                        }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}



const getDataFromStore = state => {
    return {
        authState: state.auth
    };
}

const dispatchActionsToProps = dispatch => {
    return {
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(DomainSettings)